import { useState, useEffect } from 'react';
import './App.css';
import nubImage from './assets/nub.png';
import tiktokIcon from './assets/tik-tok.png';
import instagramIcon from './assets/instagram.png';
import telegramIcon from './assets/telegram.png';
import { Twitter } from 'lucide-react';
import RandomMeme from './components/RandomMeme';

function App() {
  const [memesList, setMemesList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch memes from API on component mount
  useEffect(() => {
    const fetchMemes = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://solanapulseserver-production-9af7.up.railway.app/memeslist');

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setMemesList(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching memes:', err);
        setError('Failed to load memes. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchMemes();
  }, []);

  // Navigate to previous meme with wrap-around
  const showPrevious = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : memesList.length - 1));
  };

  // Navigate to next meme with wrap-around
  const chooseRandom = () => {
    setCurrentIndex((prev) => (prev < memesList.length - 1 ? prev + 1 : 0));
  };

  // Download meme with proper filename
  const handleDownloadImage = async (source, tag, type, id) => {
    try {
      const response = await fetch(source);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${tag}-${id}.${type.split('/')[1]}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download failed:', err);
      alert('Failed to download meme. Please try again.');
    }
  };

  return (
    <div className="App">
      <div className="landing-content">
        <h1 className="hero-text">
          $nub migrated to a new contract (1:1 via{' '}
          <a href="https://migrate.fun/claim/mig225" target="_blank" rel="noopener noreferrer">
            migrate.fun
          </a>
          )<br />
          the old token is deprecated. always trade the new one
          <span className="hero-ca">
            new ca:{' '}
            <code>4QsNTBKwHgyYUUHq9tDzk1CCVu7y5hK7z3GE9R36pump</code>{' '}
            <a
              href="https://pump.fun/coin/4QsNTBKwHgyYUUHq9tDzk1CCVu7y5hK7z3GE9R36pump"
              target="_blank"
              rel="noopener noreferrer"
            >
              trade ↗
            </a>
          </span>
        </h1>

        <div className="image-grid">
          <div className="big-square">
            <img src={nubImage} alt="Nub Cat" />
          </div>
          <div className="small-squares">
            <a href="https://t.me/nubportal" target="_blank" rel="noopener noreferrer" className="small-square">
              <img src={telegramIcon} alt="Telegram" className="social-icon" />
            </a>
            <a href="https://x.com/devgwardo" target="_blank" rel="noopener noreferrer" className="small-square">
              <Twitter size={64} strokeWidth={1.5} />
            </a>
            <a href="https://www.instagram.com/sillynubcat/?hl=en" target="_blank" rel="noopener noreferrer" className="small-square">
              <img src={instagramIcon} alt="Instagram" className="social-icon" />
            </a>
            <a href="http://tiktok.com/@sillynubcat" target="_blank" rel="noopener noreferrer" className="small-square">
              <img src={tiktokIcon} alt="TikTok" className="social-icon" />
            </a>
          </div>
        </div>

        {/* RandomMeme Component */}
        {loading ? (
          <div className="image-container">
            <div className="loading-state">Loading memes...</div>
          </div>
        ) : error ? (
          <div className="image-container">
            <div className="loading-state">{error}</div>
          </div>
        ) : memesList.length > 0 ? (
          <RandomMeme
            randomImage={memesList[currentIndex]}
            showPrevious={showPrevious}
            handleDownloadImage={handleDownloadImage}
            chooseRandom={chooseRandom}
          />
        ) : null}
      </div>
    </div>
  );
}

export default App;
